import { Service } from '../../../services';

const baseUrl = '/api/v1/pricer/multifamily-liquidity';

const url = {
  GET_LIQUIDITY: `${baseUrl}/getLiquidity`,
  LOAN_VALUES: '/api/v1/loan/getMultifamilyLoanDetail',
  MULTIFAMILY_DEAL_NAMES: '/api/v1/loan/getMultifamilyDealNames',
};

export class MultifamilyLiquidityCalculatorService extends Service {

  getLiquidity(request) {
    return this.post(url.GET_LIQUIDITY, request);
  }

  getMultifamilyDealNames(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object
  ) {
    return this.get(url.MULTIFAMILY_DEAL_NAMES, {
      page,
      pageSize,
      sortDir,
      sortBy,
      filters,
    });
  }

   getLoanValues(loanId) {
    return this.get(`${url.LOAN_VALUES}?id=${loanId}`);
  }



}
